import { authAPI } from '../services/api.js';
import gsap from 'gsap';

export function Register(appState) {
    const container = document.createElement('div');
    container.className = 'auth-container';

    container.innerHTML = `
        <div class="auth-card">
            <div class="auth-header">
                <h1>🚀 Join STEM Quest</h1>
                <p>Start Your Learning Adventure</p>
            </div>
            
            <form id="register-form" class="auth-form">
                <div class="form-group">
                    <label for="register-username">Username</label>
                    <input 
                        type="text" 
                        id="register-username" 
                        required 
                        placeholder="coollearner123"
                        minlength="3"
                        maxlength="20"
                        autocomplete="username"
                    />
                </div>
                
                <div class="form-group">
                    <label for="register-email">Email</label>
                    <input 
                        type="email" 
                        id="register-email" 
                        required 
                        placeholder="your@email.com"
                        autocomplete="email"
                    />
                </div>
                
                <div class="form-group">
                    <label for="register-password">Password</label>
                    <input 
                        type="password" 
                        id="register-password" 
                        required 
                        placeholder="••••••••"
                        autocomplete="new-password"
                        minlength="6"
                    />
                    <small>Minimum 6 characters</small>
                </div>
                
                <div class="form-group">
                    <label for="register-confirm">Confirm Password</label>
                    <input 
                        type="password" 
                        id="register-confirm" 
                        required 
                        placeholder="••••••••"
                        autocomplete="new-password"
                        minlength="6"
                    />
                </div>
                
                <div id="register-error" class="error-message"></div>
                
                <button type="submit" class="btn btn-primary" id="register-btn">
                    <span class="btn-text">Create Account</span>
                    <span class="btn-loader" style="display: none;">⏳</span>
                </button>
            </form>
            
            <div class="auth-footer">
                <p>Already have an account? <a href="#" id="show-login">Login</a></p>
            </div>
        </div>
    `;

    // Form submission
    const form = container.querySelector('#register-form');
    const errorDiv = container.querySelector('#register-error');
    const registerBtn = container.querySelector('#register-btn');
    const btnText = registerBtn.querySelector('.btn-text');
    const btnLoader = registerBtn.querySelector('.btn-loader');

    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        const username = container.querySelector('#register-username').value;
        const email = container.querySelector('#register-email').value;
        const password = container.querySelector('#register-password').value;
        const confirm = container.querySelector('#register-confirm').value;

        // Clear previous errors
        errorDiv.textContent = '';

        // Validate password match
        if (password !== confirm) {
            errorDiv.textContent = 'Passwords do not match';
            return;
        }

        // Show loading state
        btnText.style.display = 'none';
        btnLoader.style.display = 'inline';
        registerBtn.disabled = true;

        try {
            const response = await authAPI.register({
                username,
                email,
                password
            });

            if (response.success) {
                // Store user data
                appState.user = response.data.user;
                appState.isAuthenticated = true;
                appState.useBackend = true;

                // Navigate to profile setup
                const { navigateTo } = await import('../app.js');
                navigateTo('setup', appState);
            } else {
                errorDiv.textContent = response.message || 'Registration failed. Please try again.';
            }
        } catch (error) {
            errorDiv.textContent = error.message || 'Server error. Please try again.';
            console.error('Registration error:', error);
        } finally {
            btnText.style.display = 'inline';
            btnLoader.style.display = 'none';
            registerBtn.disabled = false;
        }
    });

    // Show login button
    container.querySelector('#show-login').addEventListener('click', async (e) => {
        e.preventDefault();
        const { navigateTo } = await import('../app.js');
        navigateTo('login', appState);
    });

    // Entrance animation
    gsap.from(container.querySelector('.auth-card'), {
        opacity: 0,
        y: 30,
        duration: 0.6,
        ease: 'power2.out'
    });

    return container;
}
